module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "row-box"
  }, [_c('div', {
    staticClass: "row-left"
  }, _vm._l((_vm.areaList), function(area) {
    return _c('div', {
      key: area.id,
      class: _vm.params.weiyuanhui_id == area.id ? 'left-li left-li-active' : 'left-li',
      on: {
        "click": function($event) {
          return _vm.onSelectLeft(area)
        }
      }
    }, [_vm._v(_vm._s(area.province) + "\n          ")])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "row-right"
  }, [(_vm.fenhuishow) ? _c('div', [_c('div', {
    staticClass: "news-content",
    domProps: {
      "innerHTML": _vm._s(_vm.fenhuiRow.content)
    }
  })]) : _vm._e(), _vm._v(" "), _c('van-list', {
    attrs: {
      "velse": "",
      "finished": _vm.finished,
      "finished-text": "没有更多了"
    },
    on: {
      "load": _vm.onLoad
    },
    model: {
      value: (_vm.loading),
      callback: function($$v) {
        _vm.loading = $$v
      },
      expression: "loading"
    }
  }, _vm._l((_vm.list), function(row, i) {
    return _c('div', {
      key: i,
      staticClass: "right-li flex-start"
    }, [_c('div', {
      staticClass: "right-li-img"
    }, [_c('img', {
      attrs: {
        "src": row.wechat_pic_url,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.onPreview(row)
        }
      }
    }), _vm._v(" "), _c('div', [_vm._v("加我企业微信")])]), _vm._v(" "), _c('div', {
      staticClass: "right-li-line"
    }), _vm._v(" "), _c('div', {
      staticClass: "right-li-user"
    }, [_c('div', {
      staticClass: "right-user-one"
    }, [_c('div', {
      staticClass: "right-user-label"
    }, [_vm._v("姓名")]), _vm._v(" "), _c('div', {
      staticClass: "right-user-value"
    }, [_vm._v(_vm._s(row.name))])]), _vm._v(" "), _c('div', {
      staticClass: "right-user-one"
    }, [_c('div', {
      staticClass: "right-user-label"
    }, [_vm._v("电话")]), _vm._v(" "), _c('div', {
      staticClass: "right-user-value"
    }, [_vm._v(_vm._s(row.phone))])]), _vm._v(" "), _c('div', {
      staticClass: "right-user-one"
    }, [_c('div', {
      staticClass: "right-user-label"
    }, [_vm._v("职务")]), _vm._v(" "), (row.area_type == 1) ? _c('div', {
      staticClass: "right-user-value"
    }, [_vm._v(_vm._s(row.province) + "负责人")]) : _c('div', {
      staticClass: "right-user-value"
    }, [_vm._v(_vm._s(row.city) + "负责人")])])]), _vm._v(" "), (row.area_type == 1) ? _c('div', {
      staticClass: "right-li-sign right-li-sign-province"
    }, [_vm._v(_vm._s(row.province))]) : _c('div', {
      staticClass: "right-li-sign right-li-sign-city"
    }, [_vm._v(_vm._s(row.city))])])
  }), 0)], 1)]), _vm._v(" "), _c('van-popup', {
    staticStyle: {
      "width": "80%",
      "height": "auto",
      "text-align": "center"
    },
    model: {
      value: (_vm.showCert),
      callback: function($$v) {
        _vm.showCert = $$v
      },
      expression: "showCert"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "height": "auto"
    },
    attrs: {
      "src": _vm.certUrl
    }
  }), _vm._v(" "), (!_vm.isApp) ? _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    }
  }, [_vm._v("请长按图片保存")]) : _c('van-button', {
    staticStyle: {
      "margin": "10px auto",
      "text-align": "center"
    },
    attrs: {
      "type": "default",
      "round": ""
    },
    on: {
      "click": _vm.appDownload
    }
  }, [_vm._v("点击下载图片")])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-333dd939","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/page/Jigoushezhi.vue
// module id = 2316
// module chunks = 0